import React from 'react';
import { IconTool, IconAlertTriangle } from '@tabler/icons-react';
export function MaintenanceSection() {
  return <section className="py-20 md:py-24 px-5 md:px-10 w-full bg-[#FFFFFF]" data-id="element-146">
      <div className="max-w-6xl mx-auto" data-id="element-147">
        <div className="text-center flex flex-col items-center" data-id="element-148">
          <div className="inline-block border border-accent-pink text-accent-pink rounded-full px-4 py-1 text-xs uppercase font-bold tracking-widest mb-4" data-id="element-149">
            MANUTENZIONE
          </div>

          <h2 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-navy text-center" data-id="element-150">
            Non solo pulizie. Anche{' '}
            <span className="text-accent-pink" data-id="element-151">manutenzione</span>.
          </h2>

          {/* Pink underline accent */}
          <div className="flex justify-center mt-4" data-id="element-152">
            <div style={{
            width: '40px',
            height: '3px',
            background: '#FF4081',
            borderRadius: '2px'
          }} data-id="element-153" />
          </div>

          <p className="text-center text-body-gray text-lg mt-4 max-w-2xl mx-auto font-body" data-id="element-154">
            Lo stesso approccio, applicato a tutto ciò che serve al tuo
            appartamento.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mt-12" data-id="element-155">
          {/* Card 1 — Ordinari */}
          <div className="bg-white rounded-none p-7 border-2 border-accent-teal" data-id="element-156">
            <div className="mb-4" data-id="element-157">
              <IconTool size={32} stroke={1.5} style={{
              color: '#2EDDB4'
            }} data-id="element-158" />
            </div>

            <h3 className="font-heading font-semibold text-lg md:text-xl text-navy mb-3" data-id="element-159">
              Interventi ordinari
            </h3>

            <p className="font-body text-body-gray text-sm md:text-base leading-relaxed" data-id="element-160">
              Idraulico, elettricista, serraturiere. CleanAI raggruppa le
              richieste nella tua zona e ti manda il professionista giusto, a
              costi ridotti.
            </p>

            <div className="mt-5 rounded-lg p-4 text-sm flex items-center gap-3 font-body font-medium text-accent-teal" style={{
            background: 'rgba(88,164,176,0.08)'
          }} data-id="element-161">
              <span className="inline-block w-2 h-2 rounded-full flex-shrink-0 bg-accent-teal" data-id="element-162" />
              Stessa zona, stesso tecnico, costi divisi tra host.
            </div>
          </div>

          {/* Card 2 — Urgenti */}
          <div className="relative bg-white rounded-none p-7 border-2" style={{
          borderColor: '#FF4081'
        }} data-id="element-163">
            {/* Badge */}

            <div className="mb-4" data-id="element-164">
              <IconAlertTriangle size={32} stroke={1.5} style={{
              color: '#FF4081'
            }} data-id="element-165" />
            </div>

            <h3 className="font-heading font-semibold text-lg md:text-xl text-navy mb-3" data-id="element-166">
              Interventi urgenti
            </h3>

            <p className="font-body text-body-gray text-sm md:text-base leading-relaxed" data-id="element-167">
              Check-in tra poche ore e qualcosa si è rotto? CleanAI trova chi è
              già operativo nella tua zona e lo attiva subito.
            </p>

            <div className="mt-5 rounded-lg p-4 text-sm flex items-center gap-3 font-body font-medium" style={{
            background: '#FFF0F5',
            color: '#FF4081'
          }} data-id="element-168">
              Guasto o assenza inattesa? C'è sempre qualcuno pronto vicino a te.
            </div>
          </div>
        </div>
      </div>
    </section>;
}